/**
 * @author       Richard Davey <rich@photonstorm.com>
 * @copyright    2018 Photon Storm Ltd.
 * @license      {@link https://github.com/photonstorm/phaser/blob/master/license.txt|MIT License}
 */

/**
 * @namespace Phaser.Math.Snap
 */

module.exports = {

    Ceil: require('./SnapCeil'),
    Floor: require('./SnapFloor'),
    To: require('./SnapTo')

};



//////////////////
// WEBPACK FOOTER
// ./math/snap/index.js
// module id = 835
// module chunks = 0